import { SpendingCardRegion } from '../../entities/enums/SpendingCardRegionEnum'
import { useSpendingCardRegion } from '../useSpendingCardRegion'

const cardsBusinessGraphic = require('!svg-url-loader!../../assets/spending-card-business.svg')
const cardsCommercialGraphic = require('!svg-url-loader!../../assets/spending-card-commercial.svg')
const physicalCardBusinessGraphic = require('!svg-url-loader!../../assets/spending-card-physical-business.svg')
const physicalCardCommercialGraphic = require('!svg-url-loader!../../assets/spending-card-physical-commercial.svg')

export const useSpendingCardGraphic = ({
  isPhysicalCard = false,
}: {
  isPhysicalCard?: boolean
} = {}) => {
  const { region } = useSpendingCardRegion()

  const spendingCardGraphic =
    region === SpendingCardRegion.UK
      ? isPhysicalCard
        ? physicalCardBusinessGraphic
        : cardsBusinessGraphic
      : isPhysicalCard
        ? physicalCardCommercialGraphic
        : cardsCommercialGraphic

  return { spendingCardGraphic }
}
